import {Component, Input, OnInit} from "@angular/core";
import {FUINavigationBranch} from "./navigation-branch/navigation-branch.model";

@Component({
    selector: 'fui-navigation-branches',
    templateUrl: './navigation-branches.component.html',
    styleUrls: ['./navigation-branches.component.scss'],
    standalone: false
})
export class FUINavigationBranchesComponent implements OnInit {
    @Input() branches: FUINavigationBranch[];

    constructor() {
    }

    ngOnInit() {

    }

}
